import React, { useState, useEffect } from "react";
import * as XLSX from "xlsx";
import { db } from "./firebase";
import {
  collection,
  getDocs,
  getDoc,
  doc,
} from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { apiFetch, API_BASE } from "./utils/apiClient";
import { getProjectInvoiceLabel } from "./utils/projectCalc";
import { isWallpaper, wallpaperInstallLabel, wallpaperPrintCost } from "./utils/wallpaper";

const InvoiceListPage = () => {
  const username = localStorage.getItem("username");
  const isAdmin = username === "admin";
  const navigate = useNavigate();

  const [invoices, setInvoices] = useState([]);
  // 📦 نفس بيانات الفواتير بس بدون استبعاد التكرارات - نحتاجها بزر "حذف
  // التكرارات" لأن invoices (فوق) مفلترة أصلاً وما تبين التكرار الفعلي بقاعدة البيانات
  const [rawInvoices, setRawInvoices] = useState([]);
  const [filtered, setFiltered] = useState([]);
const [exportingExcel, setExportingExcel] = useState(false);
const [deletingId, setDeletingId] = useState(null);
const [unapprovingId, setUnapprovingId] = useState(null);
// نافذة اختيار "حذف الكل" مقابل "حذف الطلب فقط" - تظهر بس لفاتورة معتمدة
const [deleteChoiceTarget, setDeleteChoiceTarget] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
const [employeeFilter, setEmployeeFilter] = useState(
  username === "rand@123"
    ? "رند"
    : username === "jumana@123"
    ? "جمانا"
    : username === "sara@123"
    ? "ساره"
    : username === "Baneen@123"
    ? "بنين"
    : username === "karena@123" || username === "karina@123"
    ? "تيهان"
    : username === "maysa@123"
    ? "مياسة"
    : ""
);
const [saleAccountFilter, setSaleAccountFilter] = useState("");
// ✅ فلتر حالة الاعتماد: "" (الكل) | "approved" | "notApproved"
const [approvalFilter, setApprovalFilter] = useState("");
// 🏗️ فلتر النوع: "" (الكل) | "invoice" (فواتير عادية) | "project" (محوّلة من حساب كلفة المشروع)
const [typeFilter, setTypeFilter] = useState("");
// 📊 عدادات الفواتير والمشاريع (كلي/معتمد/غير معتمد) ضمن نطاق باقي الفلاتر
// (بحث/موظف/حساب بيع) - بغض النظر عن فلتري الاعتماد والنوع، حتى تضل الأرقام
// مفيدة مهما كان مختار
// 🗂️ طريقة العرض: "cards" (الكروت الحالية) | "rows" (سطور للفواتير المعتمدة
// فقط: المجموع/مجموع اللوحات/سعر اللوحات) - تنحفظ بالمتصفح
const [viewMode, setViewMode] = useState(() => {
  try {
    return isAdmin && localStorage.getItem("invoiceListViewMode") === "rows" ? "rows" : "cards";
  } catch {
    return "cards";
  }
});
// بيانات النسخة المعتمدة لكل فاتورة (تنجاب بس لما ينفتح عرض السطور) - id -> data
const [approvedDataById, setApprovedDataById] = useState({});
const EMPTY_COUNTS = { total: 0, approved: 0, notApproved: 0 };
const [countsInScope, setCountsInScope] = useState({
  invoices: EMPTY_COUNTS,
  projects: EMPTY_COUNTS,
  quotes: EMPTY_COUNTS,
});

  const allowedCreators = [ "بنين",  "تيهان"];

  // ✅ منذ Phase 07-C2b صار createdBy يُكتب بـusername الخام من الباك اند
  // (مثلاً "Baneen@123") بدل الاسم العربي المعروض القديم الذي كان يُكتب من
  // الفرونت - فلتر الموظف هنا (employeeFilter) بقي يقارن بالاسم العربي
  // ("بنين") فيفشل التطابق دائماً لأي فاتورة جديدة، فتظهر عند "جميع
  // الموظفين"/عند admin (بدون فلتر) لكن ليس عند صاحبتها الفعلية. نفس جدول
  // التحويل username -> اسم عربي المستخدَم بـInvoicePage.jsx (محفوظ هناك
  // كـdead code توثيقي بعد نقل الإنشاء للباك اند). الفواتير القديمة (المكتوبة
  // بالاسم العربي مباشرة قبل هذي المرحلة) تبقى تعمل لأن الجدول يرجّع نفس
  // القيمة إذا ما لقى تطابق username.
  const USERNAME_TO_EMPLOYEE_NAME = {
    "rand@123": "رند",
    "jumana@123": "جمانا",
    "sara@123": "ساره",
    "Baneen@123": "بنين",
    "karena@123": "تيهان",
    "karina@123": "تيهان", // حساب كارينا انحوّل لتيهان (الهوية الداخلية نفسها)
    "maysa@123": "مياسة",
    "farah@123": "فرح",
    "arttouch@123": "ارت تاتش",
  };
  const resolveCreatedByName = (createdBy) =>
    USERNAME_TO_EMPLOYEE_NAME[createdBy] || createdBy;

  // 🤝 فاتورة جاية من "طلب جديد" مال ارت تاتش (partnerSource ينكتب بالباك اند)
  const isArtTouchInvoice = (inv) =>
    inv.partnerSource === "ارت تاتش" || inv.createdBy === "arttouch@123";

  // 🔑 توحيد النص للمطابقة (نشيله من المسافات الزايدة وحالة الأحرف) - نستخدمه
  // بالبحث وبكشف التكرار حتى فرق مسافة بسيط ما يخلي المطابقة تفشل
  const normalizeText = (str) => String(str || "").trim().toLowerCase().replace(/\s+/g, " ");

  // ✅ Phase 07-D: فحص "هل الفاتورة معتمدة فعلاً" الصحيح - يقبل
  // approvedVersionNumber=0 (أول نسخة) كقيمة معتمدة سليمة. فحص truthy عادي
  // (!!inv.approvedVersionNumber) كان يفشل بصمت تحديداً بهذي الحالة (كل
  // فاتورة جديدة تبدأ versionNumber من 0)، فتظهر كـ"غير معتمدة" رغم اعتمادها
  // فعلياً - نفس علة approveInvoice/loadInvoice المُصلَحة بهذي المرحلة.
  const isInvoiceApproved = (inv) =>
    inv.approvedVersionNumber !== undefined && inv.approvedVersionNumber !== null;

  // 🏗️ فاتورة محوّلة من واجهة حساب كلفة المشروع: الجديدة تحمل invoiceSource
  // بمستند الفاتورة، والقديمة (قبل إضافة العلامة) نتعرف عليها من الملاحظة
  // اللي يكتبها ProjectCostCalculator تلقائياً عند التحويل
  const PROJECT_NOTE_MARKER = "من حساب كلفة المشروع";
  // "projectInvoice" = فاتورة مشروع أنشأتها بنين مباشرة من واجهة الفاتورة
  const isProjectInvoice = (inv) =>
    inv.invoiceSource === "projectCost" ||
    inv.invoiceSource === "projectInvoice" ||
    String(inv.latestData?.notes || "").includes(PROJECT_NOTE_MARKER);

  // 📋 التسعيرات: "غير معتمدة" = بعدها تسعيرة (projectQuote)، "معتمدة" = انعتمدت
  // وتحوّلت لفاتورة مشروع (convertedFromQuote - تنحسب ويه المشاريع هم).
  // التسعيرة ما تنحسب ويه الفواتير ولا المشاريع، وما إلها قيود ولا إكسل
  const isPendingQuote = (inv) => inv.invoiceSource === "projectQuote";
  const isApprovedQuote = (inv) => inv.convertedFromQuote === true;
  const isQuoteRelated = (inv) => isPendingQuote(inv) || isApprovedQuote(inv);
  // "معتمدة" حسب الفلتر: للتسعيرات = تحوّلت لفاتورة مشروع، لغيرها = اعتماد الفاتورة
  const isApprovedInView = (inv) =>
    typeFilter === "quote" ? isApprovedQuote(inv) : isInvoiceApproved(inv);

  // 📅 تاريخ الفاتورة: نفس الحقل المكتوب بالفاتورة، وإذا ناقص تاريخ الإنشاء
  const getInvoiceDisplayDate = (inv) => {
    if (inv.latestData?.date) return inv.latestData.date;
    const seconds = inv.createdAt?.seconds;
    return seconds ? new Date(seconds * 1000).toISOString().slice(0, 10) : "—";
  };

  // 🔑 مفتاح كشف التكرار: نعتمد رقم الفاتورة إذا موجود (أدق مطابقة) - وإذا
  // مو موجود (وثيقة قديمة/ناقصة) نرجع لمجموعة (الاسم + السعر + رقم النسخة)
  const getDuplicateKey = (inv) => {
    const number = normalizeText(inv.invoiceNumber);
    if (number) return `num:${number}`;
    return `fallback:${normalizeText(inv.customerName)}__${inv.lastFinalTotal ?? ""}__${inv.lastVersionNumber ?? ""}`;
  };

 const loadInvoices = async () => {
  try {
    const snap = await getDocs(collection(db, "invoices"));

    const list = await Promise.all(
      snap.docs.map(async (d) => {
        const invoiceData = {
          id: d.id,
          ...d.data(),
        };

        let latestInvoiceData = null;

        if (invoiceData.lastVersionId) {
          const versionRef = doc(
            db,
            "invoices",
            d.id,
            "versions",
            invoiceData.lastVersionId
          );

          const versionSnap = await getDoc(versionRef);

          if (versionSnap.exists()) {
            latestInvoiceData = versionSnap.data().data || null;
          }
        }

        return {
          ...invoiceData,
          latestData: latestInvoiceData,
        };
      })
    );

    // 🔽 الأحدث أولاً: نعتمد lastUpdatedAt وإذا غير موجودة نرجع لـ createdAt
    const getSortTime = (inv) =>
      inv.lastUpdatedAt?.seconds ?? inv.createdAt?.seconds ?? 0;

    // ⛔ استبعاد الفواتير الناقصة: وثيقة أُنشئت بس ما اكتمل حفظ أي نسخة لها
    // (مثلاً بسبب فشل بالحفظ) - تظهر كبطاقة فارغة بدون صورة/مجموع/رقم نسخة
    const completeList = list.filter(
      (inv) => inv.lastVersionNumber !== undefined && inv.lastVersionNumber >= 0
    );

    completeList.sort((a, b) => getSortTime(b) - getSortTime(a));

    setRawInvoices(completeList);

    // 🧹 منع تكرار نفس الفاتورة بالواجهة: أحياناً تنولد أكثر من وثيقة لنفس
    // الفاتورة (مثلاً بسبب خلل قديم بربط الطلب بالفاتورة) - نخلي بس أحدث وثيقة
    // لكل فاتورة (completeList مرتبة أصلاً من الأحدث للأقدم فوق)
    const seen = new Set();
    const dedupedList = completeList.filter((inv) => {
      const key = getDuplicateKey(inv);
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });

    setInvoices(dedupedList);
    setFiltered(dedupedList);
  } catch (err) {
    console.error("Error loading invoices:", err);
  }
};

  useEffect(() => {
    loadInvoices();
  }, []);

  // 🗑️ Phase 07-C1: يستبدل السلسلة المباشرة (نسخ + طلبات + Storage + قيود
  // محاسبية + قيدا الكلفة + الفاتورة نفسها، كل خطوة كانت تبتلع خطأها
  // بصمت) بنداء واحد للباك اند. لا نبتلع الخطأ هنا - أي فشل جزئي بالسيرفر
  // يرجع خطأ حقيقي (وليس نجاحاً كاذباً)، فنرميه لفوق حتى handleDeleteInvoice
  // يعرضه للمستخدم بدل ما يعتقد أن الحذف تم بالكامل.
  // ⚠️ حذف Storage (صور/فيديوهات الطلبات) لم يُهاجَر بهذي المرحلة - موثَّق
  // كـrisk صريح بالتقرير، وليس بهذا النداء بعد الآن.
  const deleteInvoiceCascade = async (invoiceId) => {
    const res = await apiFetch(`${API_BASE}/invoices/${invoiceId}`, {
      method: "DELETE",
    });
    if (!res.ok) {
      const errorText = await res.text().catch(() => "");
      throw new Error(errorText || `HTTP ${res.status}`);
    }
  };

  // 🔎 يجيب حالة الطلب المرتبط بفاتورة (إن وجد) قبل أي إجراء هدّام (حذف/إلغاء
  // اعتماد) - نحتاجها لصياغة رسالة تأكيد دقيقة تحذّر المستخدم مسبقاً لو كان
  // الطلب قيد التنفيذ فعلياً. history.length > 1 يعني تقدّم فعلي بمراحل
  // العمل بعد الإنشاء (نفس المنطق المستخدم سيرفرياً بـunapproveInvoice).
  const fetchLinkedOrderInfo = async (orderId) => {
    if (!orderId) return null;
    const orderSnap = await getDoc(doc(db, "orders", orderId));
    if (!orderSnap.exists()) return null;
    const data = orderSnap.data();
    return {
      status: data.status || "—",
      inProgress: Array.isArray(data.history) && data.history.length > 1,
    };
  };

  // 📝 صياغة موحّدة لتأثير حذف/إلغاء اعتماد على الطلب المرتبط - تُستخدم
  // برسائل التأكيد لكل من حذف الفاتورة وإلغاء الاعتماد
  const describeOrderImpact = (orderInfo) => {
    if (!orderInfo) {
      return "لا يوجد طلب مرتبط حالياً بهذه الفاتورة.";
    }
    if (orderInfo.inProgress) {
      return `⚠️ تنبيه: هذه الفاتورة مرتبطة بطلب قيد التنفيذ فعلياً (الحالة الحالية: "${orderInfo.status}"). أي عمل أُنجز عليه سيُفقد نهائياً - سيتم حذفه بالكامل مع أي دفعة مقدمة مسجّلة عليه.`;
    }
    return `هذه الفاتورة مرتبطة بطلب لم يبدأ العمل عليه بعد (الحالة الحالية: "${orderInfo.status}"). سيتم حذفه مع أي دفعة مقدمة مسجّلة عليه (إن وجدت).`;
  };

  // 🗑️ حذف فاتورة بالكامل (الفاتورة + كل نسخها + أي طلب مرتبط + كل القيود
  // المحاسبية المرتبطة) - صلاحية المدير فقط. لا يمكن التراجع عنه.
  const handleDeleteInvoice = async (inv) => {
    if (!isAdmin) return;
    const invoiceId = inv.id;
    const invoiceNumber = inv.invoiceNumber;

    let orderInfo = null;
    if (inv.orderId) {
      try {
        orderInfo = await fetchLinkedOrderInfo(inv.orderId);
      } catch (err) {
        console.error("Error checking linked order:", err);
      }
    }

    const confirmMessage = orderInfo
      ? `⚠️ حذف نهائي - الفاتورة رقم ${invoiceNumber}\n\n${describeOrderImpact(
          orderInfo
        )}\n\nكما سيتم حذف الفاتورة نفسها وكل نسخها وقيود كلفة الطباعة/الإطارات المرتبطة فيها.\n\nلا يمكن التراجع عن هذا الإجراء. هل تريد المتابعة؟`
      : `⚠️ حذف نهائي - الفاتورة رقم ${invoiceNumber}\n\nسيتم حذف الفاتورة وكل نسخها، وأي طلب تحوّل منها، وقيود كلفة الطباعة/الإطارات المرتبطة فيها.\n\nلا يمكن التراجع عن هذا الإجراء. هل تريد المتابعة؟`;

    const confirmed = window.confirm(confirmMessage);
    if (!confirmed) return;

    try {
      setDeletingId(invoiceId);

      await deleteInvoiceCascade(invoiceId);

      // ✅ إزالة فورية من الواجهة (بدل الاعتماد فقط على إعادة التحميل) حتى
      // تنعرض النتيجة مباشرة حتى لو تأخر رد السيرفر
      setInvoices((prev) => prev.filter((item) => item.id !== invoiceId));
      setFiltered((prev) => prev.filter((item) => item.id !== invoiceId));

      alert(`✅ تم حذف الفاتورة رقم ${invoiceNumber} بالكامل بنجاح.`);

      await loadInvoices();
    } catch (err) {
      console.error("Error deleting invoice:", err);
      alert(`❌ حدث خطأ أثناء حذف الفاتورة:\n${err.code || ""} ${err.message || err}`);
    } finally {
      setDeletingId(null);
    }
  };

  // 🔓 إلغاء اعتماد فاتورة معتمدة - صلاحية المدير فقط (نفس القيد مفروض
  // سيرفرياً بـrequireAdmin على /invoices/:id/unapprove). يرجّع الفاتورة
  // والنسخة المعتمدة لحالة "غير معتمدة"، ويحذف قيود كلفة الطباعة/الإطارات.
  // ✅ إذا كان فيه طلب فعلي تحوّل من هذي الفاتورة، يُحذف هو الآخر (مع أي
  // قيد دفعة مقدمة مسجّل عليه) - فاتورة "غير معتمدة" ما يصح يبقى مرتبط
  // فيها طلب حي. نفس هذا الإجراء بالضبط يُستخدم أيضاً كخيار "حذف الطلب
  // فقط" بنافذة حذف الفاتورة (بدون حذف الفاتورة نفسها) - راجع openDeleteFlow.
  const handleUnapproveInvoice = async (inv) => {
    if (!isAdmin) return;
    const invoiceId = inv.id;
    const invoiceNumber = inv.invoiceNumber;

    let orderInfo = null;
    if (inv.orderId) {
      try {
        orderInfo = await fetchLinkedOrderInfo(inv.orderId);
      } catch (err) {
        console.error("Error checking linked order:", err);
      }
    }

    const confirmMessage = `هل أنت متأكد من إلغاء اعتماد الفاتورة رقم ${invoiceNumber}؟\n\n${describeOrderImpact(
      orderInfo
    )}\n\nقيود كلفة الطباعة والإطارات المرتبطة بهذا الاعتماد تنحذف من الحسابات، وتعود الفاتورة "غير معتمدة" وقابلة للتعديل - يمكن اعتمادها من جديد لاحقاً بنفس الطريقة العادية.`;

    const confirmed = window.confirm(confirmMessage);
    if (!confirmed) return;

    try {
      setUnapprovingId(invoiceId);

      const res = await apiFetch(`${API_BASE}/invoices/${invoiceId}/unapprove`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      });
      if (!res.ok) {
        const errorText = await res.text().catch(() => "");
        throw new Error(errorText || `HTTP ${res.status}`);
      }
      const result = await res.json().catch(() => ({}));

      // ✅ تحديث فوري بالواجهة بدل الاعتماد فقط على إعادة التحميل
      const stripApproval = (item) =>
        item.id === invoiceId
          ? {
              ...item,
              approvedVersionNumber: null,
              approvedVersionId: null,
              approvedFinalTotal: null,
              orderId: null,
            }
          : item;
      setInvoices((prev) => prev.map(stripApproval));
      setFiltered((prev) => prev.map(stripApproval));
      setRawInvoices((prev) => prev.map(stripApproval));

      if (result.orderDeleted) {
        alert(
          result.orderWasInProgress
            ? `✅ تم إلغاء اعتماد الفاتورة رقم ${invoiceNumber}، وتم حذف الطلب المرتبط بها (كان قيد التنفيذ) مع أي دفعة مقدمة مسجّلة عليه.`
            : `✅ تم إلغاء اعتماد الفاتورة رقم ${invoiceNumber}، وتم حذف الطلب المرتبط بها (لم يكن قد بدأ العمل عليه) مع أي دفعة مقدمة مسجّلة عليه.`
        );
      } else {
        alert(`✅ تم إلغاء اعتماد الفاتورة رقم ${invoiceNumber}.`);
      }

      await loadInvoices();
    } catch (err) {
      console.error("Error unapproving invoice:", err);
      alert(`❌ حدث خطأ أثناء إلغاء الاعتماد:\n${err.message || err}`);
    } finally {
      setUnapprovingId(null);
    }
  };

  // 🗂️ نقطة الدخول لزر "حذف الفاتورة": فاتورة غير معتمدة → حذف مباشر
  // (ما فيها طلب مرتبط أصلاً). فاتورة معتمدة → تفتح نافذة اختيار بين حذف
  // كل شي أو حذف الطلب فقط (راجع deleteChoiceTarget/modal تحت بالـJSX).
  const openDeleteFlow = (inv) => {
    if (!isAdmin) return;
    if (isInvoiceApproved(inv)) {
      setDeleteChoiceTarget(inv);
    } else {
      handleDeleteInvoice(inv);
    }
  };

  const confirmDeleteAllFromModal = () => {
    const inv = deleteChoiceTarget;
    setDeleteChoiceTarget(null);
    if (inv) handleDeleteInvoice(inv);
  };

  const confirmDeleteOrderOnlyFromModal = () => {
    const inv = deleteChoiceTarget;
    setDeleteChoiceTarget(null);
    if (inv) handleUnapproveInvoice(inv);
  };

  // 🧹 حذف التكرارات: يفحص كل الفواتير، يلكط أي مجموعة عندها نفس رقم الفاتورة
  // (أو نفس الاسم + السعر + رقم النسخة إذا رقم الفاتورة ناقص)، ويبقي بس أحدث
  // وحدة من كل مجموعة ويحذف الباقي بالكامل (نسخها + الطلب المرتبط + قيود الكلفة).
  // هذا زر يكدر المدير يستخدمه بأي وقت لتنظيف أي تكرار يصير مستقبلاً
  const handleRemoveDuplicates = async () => {
    if (!isAdmin) return;

    const groups = new Map();
    rawInvoices.forEach((inv) => {
      const key = getDuplicateKey(inv);
      if (!groups.has(key)) groups.set(key, []);
      groups.get(key).push(inv);
    });

    // كل مجموعة فيها أكثر من فاتورة = تكرار - نبقي الأحدث (rawInvoices مرتبة
    // أصلاً من الأحدث للأقدم بفضل loadInvoices) ونحذف الباقي
    const toDelete = [];
    groups.forEach((group) => {
      if (group.length > 1) {
        toDelete.push(...group.slice(1));
      }
    });

    if (toDelete.length === 0) {
      alert("✅ ما اكو تكرار حالياً بقائمة الفواتير.");
      return;
    }

    const confirmed = window.confirm(
      `⚠️ اكتشفنا ${toDelete.length} فاتورة مكررة. راح نبقي أحدث نسخة من كل فاتورة ونحذف الباقي نهائياً (مع نسخها والطلبات وقيود الكلفة المرتبطة فيها).\nهل تريد المتابعة؟`
    );
    if (!confirmed) return;

    try {
      setDeletingId("duplicates");

      const results = await Promise.allSettled(
        toDelete.map((inv) => deleteInvoiceCascade(inv.id))
      );

      const failedCount = results.filter((r) => r.status === "rejected").length;
      results
        .filter((r) => r.status === "rejected")
        .forEach((r) => console.error("تعذر حذف فاتورة مكررة:", r.reason));

      const deletedIds = new Set(toDelete.map((inv) => inv.id));
      setInvoices((prev) => prev.filter((inv) => !deletedIds.has(inv.id)));
      setFiltered((prev) => prev.filter((inv) => !deletedIds.has(inv.id)));

      alert(
        failedCount === 0
          ? `✅ تم حذف ${toDelete.length} فاتورة مكررة، وبقت بس النسخة الأحدث من كل فاتورة.`
          : `✅ تم حذف ${toDelete.length - failedCount} فاتورة مكررة.\n❌ فشل حذف ${failedCount} - جرب مرة ثانية.`
      );

      await loadInvoices();
    } catch (err) {
      console.error("Error removing duplicates:", err);
      alert("❌ حدث خطأ أثناء حذف التكرارات.");
    } finally {
      setDeletingId(null);
    }
  };

  const applyFilter = () => {
    // ✅ أي خطأ غير متوقع (مثلاً حقل بشكل غريب بفاتورة معينة) لازم ما يوقف
    // الفلترة بالكامل بصمت - نلتقطه ونطلع نتيجة معقولة بدل ما تجمد النتائج
    try {
      let data = [...invoices];

      // فواتير ارت تاتش تظهر بأي فلتر موظفة (مثلاً الفلتر الافتراضي "بنين")
      // لأن فريق الفواتير هو اللي يراجعها ويعتمدها - مو بس صاحبة الفاتورة.
      // خيار "ارت تاتش" بالفلتر يعرضها هي فقط.
      if (employeeFilter === "ارت تاتش") {
        data = data.filter(isArtTouchInvoice);
      } else if (employeeFilter !== "") {
        data = data.filter(
          (inv) =>
            isArtTouchInvoice(inv) ||
            resolveCreatedByName(inv.createdBy) === employeeFilter ||
            // 🏗️ مشروع أرسله المدير لموظفة (projectAssignedTo) يظهر بفلترها
            resolveCreatedByName(inv.projectAssignedTo) === employeeFilter ||
            // + مشاريع المدير القديمة (أُرسلت قبل إضافة projectAssignedTo)
            // تروح لبنين بنفس الشكل
            (employeeFilter === "بنين" &&
              inv.createdBy === "admin" &&
              isProjectInvoice(inv))
        );
      }

      if (saleAccountFilter !== "") {
        data = data.filter(
          (inv) => (inv.saleAccount || inv.latestData?.saleAccount || "بيع") === saleAccountFilter
        );
      }

      // 🔍 بحث موحد: يطابق اسم الزبون أو رقم الفاتورة بمجرد الكتابة (فلترة فورية،
      // بدون الحاجة لزر بحث). نتحقق من اسم الزبون بالوثيقة الرئيسية وبآخر نسخة
      // محفوظة (احتياطاً لو الحقل الرئيسي فاضي بفواتير قديمة)
      const q = normalizeText(searchQuery);
      if (q !== "") {
        data = data.filter((inv) => {
          const customerName = normalizeText(inv.customerName || inv.latestData?.customerName);
          const invoiceNumber = normalizeText(inv.invoiceNumber);
          return customerName.includes(q) || invoiceNumber.includes(q);
        });
      }

      // 📊 العدادات ضمن نفس نطاق البحث/الموظف/حساب البيع - قبل تطبيق فلتري
      // الاعتماد والنوع، حتى تبقى الأرقام مفيدة بأي حالة فلتر مختارة
      const countGroup = (list) => {
        const approved = list.filter(isInvoiceApproved).length;
        return { total: list.length, approved, notApproved: list.length - approved };
      };
      const quotes = data.filter(isQuoteRelated);
      const approvedQuotes = quotes.filter(isApprovedQuote).length;
      setCountsInScope({
        invoices: countGroup(data.filter((inv) => !isProjectInvoice(inv) && !isPendingQuote(inv))),
        projects: countGroup(data.filter(isProjectInvoice)),
        quotes: { total: quotes.length, approved: approvedQuotes, notApproved: quotes.length - approvedQuotes },
      });

      if (typeFilter === "invoice") {
        data = data.filter((inv) => !isProjectInvoice(inv) && !isPendingQuote(inv));
      } else if (typeFilter === "project") {
        data = data.filter(isProjectInvoice);
      } else if (typeFilter === "quote") {
        data = data.filter(isQuoteRelated);
      }

      if (approvalFilter === "approved") {
        data = data.filter(isApprovedInView);
      } else if (approvalFilter === "notApproved") {
        data = data.filter((inv) => !isApprovedInView(inv));
      }

      setFiltered(data);
    } catch (err) {
      console.error("خطأ أثناء فلترة الفواتير:", err);
      setFiltered([]);
    }
  };

  useEffect(() => {
    applyFilter();
  }, [searchQuery, employeeFilter, saleAccountFilter, approvalFilter, typeFilter, invoices]);
const ceilToStep = (value, step) => Math.ceil(value / step) * step;

const parseSize = (sizeKey) => {
  if (!sizeKey) return { width: 0, height: 0 };

  const cleanSize = sizeKey.replace("×", "x").replace(/\s/g, "");
  const [width, height] = cleanSize.split("x").map(Number);

  return {
    width: Number(width || 0),
    height: Number(height || 0),
  };
};

const calculateCostBreakdown = (item) => {
  const { width, height } = parseSize(item.sizeKey);

  if (width <= 0 || height <= 0) {
    return {
      printCost: 0,
      innerWoodCost: 0,
      frameCost: 0,
      totalCost: 0,
    };
  }

  // 🧻 ورق جدران: معادلته غير الكانفاس - المساحة × سعر المتر (نفس رقم واجهة
  // حساب سعر اللوحة، مع تركيب/بدون)، بدون خشب ولا إطار (utils/wallpaper.js)
  if (isWallpaper(item)) {
    const printCost = wallpaperPrintCost(item, width, height);
    return { printCost, innerWoodCost: 0, frameCost: 0, totalCost: printCost };
  }

  const printCost =
    ceilToStep((height / 100 + 0.05) * (width / 100 + 0.05), 0.2) * 25000;

  const baseDim = Math.ceil((height / 100 + width / 100) * 2 + 0.5);

  const innerWoodCost =
    item.frameOption === "إطار داخلي فقط" || item.frameOption === "إطار كامل"
      ? baseDim * 2000
      : 0;

  let frameCost = 0;

  if (item.frameOption === "إطار كامل") {
    if (item.frameType === "L") {
      frameCost = baseDim * 5500;
    }

    if (item.frameType === "Kas") {
      frameCost = baseDim * 7500;
    }
  }

  return {
    printCost,
    innerWoodCost,
    frameCost,
    totalCost: printCost + innerWoodCost + frameCost,
  };
};

const formatInvoiceDate = (approvedInvoiceData, inv) => {
  if (approvedInvoiceData?.date) return approvedInvoiceData.date;
  if (inv?.date) return inv.date;

  if (approvedInvoiceData?.createdAt?.toDate) {
    return approvedInvoiceData.createdAt.toDate().toISOString().slice(0, 10);
  }

  if (inv?.createdAt?.toDate) {
    return inv.createdAt.toDate().toISOString().slice(0, 10);
  }

  return "";
};

// 🗂️ عرض السطور: الفواتير المعتمدة فقط (ضمن نفس الفلاتر)
const approvedRows = viewMode === "rows" ? filtered.filter(isApprovedInView) : [];

// نجيب بيانات النسخة المعتمدة (مو آخر نسخة) للفواتير الظاهرة - نفس مصدر
// أرقام تصدير الإكسل
useEffect(() => {
  if (viewMode !== "rows") return;
  const missing = approvedRows.filter((inv) => !(inv.id in approvedDataById));
  if (!missing.length) return;
  let alive = true;
  Promise.all(
    missing.map(async (inv) => {
      try {
        if (inv.approvedVersionId === inv.lastVersionId && inv.latestData) {
          return [inv.id, inv.latestData];
        }
        if (inv.approvedVersionId) {
          const snap = await getDoc(doc(db, "invoices", inv.id, "versions", inv.approvedVersionId));
          if (snap.exists()) return [inv.id, snap.data().data || null];
        }
        const versionsSnap = await getDocs(collection(db, "invoices", inv.id, "versions"));
        const approved = versionsSnap.docs
          .map((d) => d.data())
          .filter((v) => v.approved === true)
          .sort((a, b) => Number(b.versionNumber || 0) - Number(a.versionNumber || 0))[0];
        return [inv.id, approved?.data || inv.latestData || null];
      } catch (err) {
        console.error("Error loading approved invoice version:", err);
        return [inv.id, inv.latestData || null];
      }
    })
  ).then((entries) => {
    if (alive) setApprovedDataById((prev) => ({ ...prev, ...Object.fromEntries(entries) }));
  });
  return () => {
    alive = false;
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [viewMode, filtered]);

// الأرقام الثلاثة لكل فاتورة معتمدة: المجموع النهائي، مجموع اللوحات (subtotal)،
// وسعر اللوحات (كلفة الإنتاج: طباعة + خشب + إطار - نفس "إجمالي التكلفة" بالإكسل)
// المعتمدة من نسختها المعتمدة، وغير المعتمدة من آخر نسخة محفوظة
const getRowTotals = (inv) => {
  const data = isInvoiceApproved(inv) ? approvedDataById[inv.id] : inv.latestData;
  if (!data) return null;
  const cost = (data.items || []).reduce((sum, item) => {
    const quantity = Number(item.quantity || 0);
    const { width, height } = parseSize(item.sizeKey);
    if (width <= 0 || height <= 0 || quantity <= 0) return sum;
    return sum + calculateCostBreakdown(item).totalCost * quantity;
  }, 0);
  return {
    finalTotal: Number(data.finalTotal ?? inv.approvedFinalTotal ?? 0),
    panelsTotal: Number(data.subtotal || 0),
    cost,
  };
};

const pendingRows =
  viewMode === "rows" ? filtered.filter((inv) => !isApprovedInView(inv)) : [];

const sumRows = (list) =>
  list.reduce(
    (acc, inv) => {
      const t = getRowTotals(inv);
      if (!t) return acc;
      acc.finalTotal += t.finalTotal;
      acc.panelsTotal += t.panelsTotal;
      acc.cost += t.cost;
      return acc;
    },
    { finalTotal: 0, panelsTotal: 0, cost: 0 }
  );
const rowsLoading = approvedRows.some((inv) => !(inv.id in approvedDataById));

// قسم سطور (معتمدة أو غير معتمدة): بوكسات المجموع فوك + سطر لكل فاتورة
const renderRowsSection = (title, list, loading) => {
  const summary = sumRows(list);
  return (
    <div style={{ marginBottom: 28 }}>
      <h3 style={{ margin: "0 0 10px", fontSize: 19 }}>
        {title} <span style={{ fontSize: 14, color: "#666" }}>({list.length})</span>
      </h3>
      <div style={rowsSummaryBar}>
        <div style={{ ...amountBox, ...amountYellow, ...summaryAmountBox }}>
          <span style={summaryLabel}>المجموع</span>
          {fmtNum(summary.finalTotal)}
        </div>
        <div style={{ ...amountBox, ...amountGreen, ...summaryAmountBox }}>
          <span style={summaryLabel}>مجموع اللوحات</span>
          {fmtNum(summary.panelsTotal)}
        </div>
        <div style={{ ...amountBox, ...amountRed, ...summaryAmountBox }}>
          <span style={summaryLabel}>سعر اللوحات</span>
          {fmtNum(summary.cost)}
        </div>
        {loading && (
          <span style={{ fontSize: 13, color: "#666" }}>⏳ جاري حساب الأرقام...</span>
        )}
      </div>

      {list.length === 0 && (
        <div style={{ textAlign: "center", color: "#888", padding: 20 }}>
          لا توجد فواتير ضمن الفلاتر الحالية
        </div>
      )}

      {list.map((inv) => {
        const t = getRowTotals(inv);
        return (
          <div key={inv.id} onClick={() => navigate(`/invoice/${inv.id}`)} style={invoiceRow}>
            <div style={{ minWidth: 0 }}>
              <div style={{ fontWeight: 700, fontSize: 16 }}>
                {inv.customerName || inv.latestData?.customerName || "—"}
              </div>
              <div style={{ fontSize: 13, color: "#666", marginTop: 4 }}>
                {getInvoiceDisplayDate(inv)}
              </div>
            </div>
            <div style={rowAmounts}>
              <div style={{ ...amountBox, ...amountYellow }}>{t ? fmtNum(t.finalTotal) : "…"}</div>
              <div style={{ ...amountBox, ...amountGreen }}>{t ? fmtNum(t.panelsTotal) : "…"}</div>
              <div style={{ ...amountBox, ...amountRed }}>{t ? fmtNum(t.cost) : "…"}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
const fmtNum = (n) => Number(n || 0).toLocaleString("en-US");

const exportFramesExcel = async () => {
  if (exportingExcel) return;

  setExportingExcel(true);

  const rows = [];
  const summaryMap = {};
  const feesRows = [];

  try {
    // ✅ "filtered" مبني من دي-دبليكيشن تم قبل ما نعرف مين الوثيقة المعتمدة
    // فعلياً (عند تكرار رقم الفاتورة). لو الوثيقة المختارة بالصدفة مو
    // المعتمدة، كنا نخسر فاتورة معتمدة حقيقية من التصدير. هنا نتأكد من حالة
    // الاعتماد لكل نسخ التكرار (من rawInvoices) قبل ما نقرر مين نصدّر
    const visibleKeys = new Set(filtered.map((inv) => getDuplicateKey(inv)));
    const candidatesByKey = new Map();
    rawInvoices.forEach((inv) => {
      const key = getDuplicateKey(inv);
      if (!visibleKeys.has(key)) return;
      if (!candidatesByKey.has(key)) candidatesByKey.set(key, []);
      candidatesByKey.get(key).push(inv);
    });

    // ⚡ نجيب "versions" لكل الفواتير (وكل نسخ التكرار) بالتوازي بدل التسلسل
    // (await وحدة وحدة كان يعني رحلة شبكة منفصلة لكل فاتورة، وهذا السبب
    // الرئيسي لبطء التصدير مع وجود عدد كبير من الفواتير)
    const exportListResults = await Promise.all(
      filtered.map(async (inv) => {
        const key = getDuplicateKey(inv);
        const candidates = candidatesByKey.get(key) || [inv];

        const candidatesWithVersions = await Promise.all(
          candidates.map(async (candidate) => {
            const versionsSnap = await getDocs(
              collection(db, "invoices", candidate.id, "versions")
            );
            const approvedVersions = versionsSnap.docs
              .map((d) => ({ id: d.id, ...d.data() }))
              .filter((version) => version.approved === true)
              .sort(
                (a, b) =>
                  Number(b.versionNumber || 0) - Number(a.versionNumber || 0)
              );
            return { candidate, approvedVersions };
          })
        );

        const found = candidatesWithVersions.find(
          (c) => c.approvedVersions.length > 0
        );

        if (!found) return null;
        return { inv: found.candidate, approvedVersions: found.approvedVersions };
      })
    );

    const exportList = exportListResults.filter(Boolean);

    for (const { inv, approvedVersions } of exportList) {
      const approvedVersion = approvedVersions[0];
      const approvedInvoiceData = approvedVersion.data;
      const items = approvedInvoiceData?.items || [];

      // الشيت الثالث: أجور الفاتورة (سعر اللوحات + أجور الاستشارة والتصميم +
      // أجور التركيب + أجور النقل)، للاستخدام الداخلي فقط — بغض النظر عن كون
      // أجور النقل مخفية عن الزبون بواجهة الفاتورة أم لا
      const panelsPrice = Number(approvedInvoiceData.subtotal || 0);
      const consultationFee = Number(approvedInvoiceData.consultationFee || 0);
      const installationFee = Number(approvedInvoiceData.installationFee || 0);
      const transportFee = Number(approvedInvoiceData.transportFee || 0);
      const siteVisitFee = Number(approvedInvoiceData.siteVisitFee || 0);
      // بطلب المستخدم: تركيب + زيارة موقع + استشارة وتصميم فقط - بدون النقل
      const servicesTotal = installationFee + siteVisitFee + consultationFee;
      const initialTotal = panelsPrice + servicesTotal;

      // "إجمالي التكلفة" هنا = نفس قيمة "إجمالي التكلفة" بشيت التفاصيل (تكلفة
      // إنتاج فعلية: طباعة + خشب + إطار)، مجموعة على كل لوحات هذه الفاتورة -
      // وليس مجموع الأسعار قبل الخصم. نطبّق نفس شرط تخطي العناصر المستخدم
      // بشيت التفاصيل حتى تتطابق القيمتين تماماً لنفس الفاتورة.
      const invoiceTotalCost = items.reduce((sum, item) => {
        const quantity = Number(item.quantity || 0);
        const { width, height } = parseSize(item.sizeKey);
        if (width <= 0 || height <= 0 || quantity <= 0) return sum;
        const costs = calculateCostBreakdown(item);
        return sum + costs.totalCost * quantity;
      }, 0);

      feesRows.push({
        "تاريخ الفاتورة": formatInvoiceDate(approvedInvoiceData, inv),
        "رقم الفاتورة": approvedInvoiceData.invoiceNumber || inv.invoiceNumber || "",
        "اسم الزبون": approvedInvoiceData.customerName || inv.customerName || "",
        "رقم هاتف الزبون": approvedInvoiceData.phone || inv.phone || "",
        "حساب البيع": approvedInvoiceData.saleAccount || inv.saleAccount || "بيع",
        "المجموع النهائي": Number(approvedInvoiceData.finalTotal || 0),
        "اجمالي سعر اللوحات": panelsPrice,
        "إجمالي التكلفة": invoiceTotalCost,
        " ": "",
        "اجمالي سعر الخدمات": servicesTotal,
        "المجموع الأولي": initialTotal,
        "اجور نقل": transportFee,
        "الخصم": Number(approvedInvoiceData.discount || 0),
        "اجور تركيب": installationFee,
        "اجور استشارة وتصميم": consultationFee,
        "زيارة الموقع": siteVisitFee,
        "اجور النقل مخفية عن الزبون؟": approvedInvoiceData.hideTransportFeeFromCustomer
          ? "نعم"
          : "لا",
      });

      items.forEach((item) => {
        const quantity = Number(item.quantity || 0);
        const { width, height } = parseSize(item.sizeKey);
        // ✅ نفس شرط تخطي العناصر المستخدم بحساب كلفة الفاتورة عند الاعتماد
        // (calculateInvoiceProductionCosts)، حتى يتساوى مجموع هذا التصدير مع
        // بوكسات "كلفة الطباعة"/"كلفة الإطارات" بسستم الحسابات
        if (width <= 0 || height <= 0 || quantity <= 0) return;

        const size = item.sizeKey || "";
        // 🧻 ورق الجدران ينفصل بسطر خاص بالخلاصة (مع/بدون تركيب) بدل نوع الإطار
        const frameType = isWallpaper(item)
          ? `ورق جدران - ${wallpaperInstallLabel(item)}`
          : item.frameType || "";

        const frameColor =
          item.frameColor === "أخرى"
            ? item.customFrameColor || ""
            : item.frameColor || "";

        const pricePerPanel = Number(item.pricePerPanel || 0);
        const totalLinePrice = Number(item.total || pricePerPanel * quantity);

        const invoiceDate = formatInvoiceDate(approvedInvoiceData, inv);

        const costs = calculateCostBreakdown(item);

        const printCostTotal = costs.printCost * quantity;
        const innerWoodCostTotal = costs.innerWoodCost * quantity;
        const frameCostTotal = costs.frameCost * quantity;
        const totalCostAll = costs.totalCost * quantity;

        // الشيت الأول: تفاصيل حسب الفاتورة والزبون
        rows.push({
          "تاريخ الفاتورة": invoiceDate,
          "رقم الفاتورة": approvedInvoiceData.invoiceNumber || inv.invoiceNumber || "",
          "اسم الزبون": approvedInvoiceData.customerName || inv.customerName || "",
          "رقم هاتف الزبون": approvedInvoiceData.phone || inv.phone || "",
          "القياس": size,
          "نوع الاطار": frameType,
          "لون الاطار": frameColor,
          "العدد": quantity,

          "سعر اللوحة": pricePerPanel,
          "السعر الكلي للسطر": totalLinePrice,

          "تكلفة الطباعة للوحة": costs.printCost,
          "تكلفة الخشب للوحة": costs.innerWoodCost,
          "تكلفة الاطار للوحة": costs.frameCost,
          "مجموع التكلفة للوحة": costs.totalCost,

          "إجمالي تكلفة الطباعة": printCostTotal,
          "إجمالي تكلفة الخشب": innerWoodCostTotal,
          "إجمالي تكلفة الاطار": frameCostTotal,
          "إجمالي التكلفة": totalCostAll,
        });

        // الشيت الثاني: خلاصة مجمعة بغض النظر عن الزبون
        const key = `${size}__${frameType}__${frameColor}`;

        if (!summaryMap[key]) {
          summaryMap[key] = {
            "القياس": size,
            "نوع الاطار": frameType,
            "لون الاطار": frameColor,
            "مجموع العدد المباع": 0,

            "إجمالي المبيعات": 0,
            "إجمالي تكلفة الطباعة": 0,
            "إجمالي تكلفة الخشب": 0,
            "إجمالي تكلفة الاطار": 0,
            "إجمالي التكلفة": 0,
          };
        }

        summaryMap[key]["مجموع العدد المباع"] += quantity;
        summaryMap[key]["إجمالي المبيعات"] += totalLinePrice;
        summaryMap[key]["إجمالي تكلفة الطباعة"] += printCostTotal;
        summaryMap[key]["إجمالي تكلفة الخشب"] += innerWoodCostTotal;
        summaryMap[key]["إجمالي تكلفة الاطار"] += frameCostTotal;
        summaryMap[key]["إجمالي التكلفة"] += totalCostAll;
      });
    }

    if (rows.length === 0) {
      alert("لا توجد فواتير معتمدة للتصدير");
      return;
    }

    const summaryRows = Object.values(summaryMap);

    const detailsWorksheet = XLSX.utils.json_to_sheet(rows);
    const summaryWorksheet = XLSX.utils.json_to_sheet(summaryRows);
    const feesWorksheet = XLSX.utils.json_to_sheet(feesRows);

    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(
      workbook,
      detailsWorksheet,
      "تفاصيل الفواتير"
    );

    XLSX.utils.book_append_sheet(
      workbook,
      summaryWorksheet,
      "الخلاصة"
    );

    XLSX.utils.book_append_sheet(
      workbook,
      feesWorksheet,
      "أجور الفواتير"
    );

    XLSX.writeFile(workbook, "تقرير الفواتير المعتمدة.xlsx");

    alert("✅ تم تصدير ملف الإكسل بنجاح");
  } catch (err) {
    console.error("Error exporting approved invoices:", err);
    alert("حدث خطأ أثناء تصدير الفواتير المعتمدة");
  } finally {
    setExportingExcel(false);
  }
};


  return (
    <div
      style={{
        width: "100%",
        minHeight: "100vh",
        backgroundColor: "#f4f4f4",
        padding: "20px",
      }}
    >
      <h2
        style={{
          textAlign: "center",
          marginBottom: 20,
          fontSize: 26,
          fontWeight: 700,
        }}
      >
        📄 قائمة الفواتير
      </h2>

      {/* فلاتر */}
      <div
        style={{
          background: "#fff",
          padding: 15,
          borderRadius: 10,
          marginBottom: 20,
          boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
        }}
      >
        <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
          <input
            type="text"
            placeholder="🔍 بحث باسم الزبون أو رقم الفاتورة"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            style={{ ...inputFilter, minWidth: 260 }}
          />

          <select
            style={inputFilter}
            value={employeeFilter}
            onChange={(e) => setEmployeeFilter(e.target.value)}
          >
            <option value="">جميع الموظفين</option>
       
            <option value="بنين">بنين</option>
            <option value="تيهان">تيهان</option>
              <option value="مياسة">مياسة</option>
            <option value="admin">المدير</option>
            <option value="ارت تاتش">🤝 ارت تاتش</option>
          </select>

          <select
            style={inputFilter}
            value={saleAccountFilter}
            onChange={(e) => setSaleAccountFilter(e.target.value)}
          >
            <option value="">كل حسابات البيع</option>
            <option value="بيع">بيع</option>
            <option value="حساب استاذ مروان">حساب استاذ مروان</option>
            <option value="حساب نرسي">حساب نرسي</option>
            <option value="مطبعة صدى سومر - أبو زينب (زبون)">مطبعة صدى سومر - أبو زينب (زبون)</option>
            <option value="ماركتنك">ماركتنك</option>
          </select>

          {/* فلتر المعتمدة/غير المعتمدة والفواتير/المشاريع صار من العدادات تحت
              (الضغط على العداد المفعّل مرة ثانية يرجّع الكل) */}
     {username !== "Baneen@123" && (
  <button
    onClick={exportFramesExcel}
    disabled={exportingExcel}
    style={{
      padding: "10px 18px",
      borderRadius: "6px",
      border: "none",
      background: exportingExcel ? "#6c757d" : "#198754",
      color: "#fff",
      fontSize: 14,
      fontWeight: "600",
      cursor: exportingExcel ? "not-allowed" : "pointer",
      opacity: exportingExcel ? 0.8 : 1,
    }}
  >
    {exportingExcel ? "⏳ جاري سحب الإكسل..." : "📥 تصدير إكسل"}
  </button>
)}

          {/* 🗂️ تبديل طريقة العرض - للمدير فقط */}
          {isAdmin && (
          <button
            onClick={() => {
              const next = viewMode === "rows" ? "cards" : "rows";
              setViewMode(next);
              try {
                localStorage.setItem("invoiceListViewMode", next);
              } catch {
                // تجاهل
              }
            }}
            style={{
              padding: "10px 18px",
              borderRadius: 6,
              border: "1px solid #0d6efd",
              background: viewMode === "rows" ? "#0d6efd" : "#fff",
              color: viewMode === "rows" ? "#fff" : "#0d6efd",
              fontSize: 14,
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            {viewMode === "rows" ? "🗂️ عرض الكروت" : "📋 عرض سطور"}
          </button>
          )}


        </div>

        {/* 📊 العدادات - الضغط على أي رقم يطبّق الفلتر المقابل، وعلى المفعّل يلغيه */}
        <div style={countsRow}>
          {[
            { type: "invoice", label: "🧾 الفواتير", counts: countsInScope.invoices },
            { type: "project", label: "🏗️ المشاريع", counts: countsInScope.projects },
            { type: "quote", label: "📋 التسعيرات", counts: countsInScope.quotes },
          ].map(({ type, label, counts }) => (
            <div key={type} style={countsGroup}>
              <span style={countsGroupLabel}>{label}</span>
              {[
                { approval: "", text: "الكلي", value: counts.total, colors: countChipTotal },
                { approval: "approved", text: "✅ معتمدة", value: counts.approved, colors: countChipApproved },
                { approval: "notApproved", text: "⏳ غير معتمدة", value: counts.notApproved, colors: countChipPending },
              ].map(({ approval, text, value, colors }) => {
                const active = typeFilter === type && approvalFilter === approval;
                return (
                  <button
                    key={approval || "all"}
                    onClick={() => {
                      setTypeFilter(active ? "" : type);
                      setApprovalFilter(active ? "" : approval);
                    }}
                    style={{
                      ...countChip,
                      ...colors,
                      outline: active ? "2px solid #0d6efd" : "none",
                    }}
                  >
                    {text}: <strong>{value}</strong>
                  </button>
                );
              })}
            </div>
          ))}
        </div>
      </div>

      {isAdmin && viewMode === "rows" ? (
        <div>
          {typeFilter === "quote" ? (
            <>
              {renderRowsSection("✅ التسعيرات المعتمدة (تحوّلت لفاتورة مشروع)", approvedRows, rowsLoading)}
              {renderRowsSection("⏳ التسعيرات غير المعتمدة", pendingRows, false)}
            </>
          ) : (
            <>
              {renderRowsSection("✅ الفواتير المعتمدة", approvedRows, rowsLoading)}
              {renderRowsSection("⏳ الفواتير غير المعتمدة", pendingRows, false)}
            </>
          )}
        </div>
      ) : (
      /* قائمة الفواتير */
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(310px, 1fr))",
          gap: 20,
        }}
      >
        {filtered.map((inv) => (
          <div
            key={inv.id}
            // الضغط على أي مكان بالكارت يفتح الفاتورة (الأزرار الداخلية توقف الضغطة)
            onClick={() => navigate(`/invoice/${inv.id}`)}
            style={{
              background: "#fff",
              padding: 15,
              borderRadius: 10,
              boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
              border: "1px solid #ddd",
              cursor: "pointer",
            }}
          >
            {/* الصورة - صورة الفاتورة طويلة، فنعرض رأسها (الشعار + معلومات
                الزبون + بداية الجدول) بدل منتصفها: القص من النص كان يطلّع
                أحياناً جزء فارغ أبيض وأحياناً جدول مقصوص، فتبين البطاقات غير
                متناسقة */}
            {inv.lastImageUrl ? (
              <img
                src={inv.lastImageUrl}
                alt=""
                loading="lazy"
                style={{
                  width: "100%",
                  height: 170,
                  objectFit: "cover",
                  objectPosition: "top",
                  borderRadius: 6,
                  border: "1px solid #eee",
                  display: "block",
                }}
              />
            ) : (
              <div
                style={{
                  width: "100%",
                  height: 170,
                  background: "#eee",
                  borderRadius: 6,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#777",
                }}
              >
                بدون صورة
              </div>
            )}

            {/* التفاصيل */}
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: 12 }}>
              <h3 style={{ margin: 0 }}>
                👤 {inv.customerName}
              </h3>

              <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                {isQuoteRelated(inv) && (
                  <span
                    style={{
                      fontSize: 12,
                      fontWeight: 700,
                      padding: "4px 10px",
                      borderRadius: 20,
                      whiteSpace: "nowrap",
                      background: "#fff8e1",
                      color: "#7a5200",
                    }}
                  >
                    {isPendingQuote(inv) ? "📋 تسعيرة" : "📋 من تسعيرة"}
                  </span>
                )}
                {isProjectInvoice(inv) && (
                  <span
                    style={{
                      fontSize: 12,
                      fontWeight: 700,
                      padding: "4px 10px",
                      borderRadius: 20,
                      whiteSpace: "nowrap",
                      background: "#ede7f6",
                      color: "#4527a0",
                    }}
                  >
                    {getProjectInvoiceLabel(inv.createdBy)}
                  </span>
                )}
                {isArtTouchInvoice(inv) && (
                  <span
                    style={{
                      fontSize: 12,
                      fontWeight: 700,
                      padding: "4px 10px",
                      borderRadius: 20,
                      whiteSpace: "nowrap",
                      background: "#e3f2fd",
                      color: "#0d47a1",
                    }}
                  >
                    🤝 ارت تاتش
                  </span>
                )}
                <span
                  style={{
                    fontSize: 12,
                    fontWeight: 700,
                    padding: "4px 10px",
                    borderRadius: 20,
                    whiteSpace: "nowrap",
                    background: isInvoiceApproved(inv) ? "#d4edda" : "#fff3cd",
                    color: isInvoiceApproved(inv) ? "#155724" : "#856404",
                  }}
                >
                  {isInvoiceApproved(inv) ? "✅ معتمدة" : "⏳ غير معتمدة"}
                </span>

                {isAdmin && isInvoiceApproved(inv) && (
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      handleUnapproveInvoice(inv);
                    }}
                    disabled={unapprovingId === inv.id}
                    title="إلغاء اعتماد الفاتورة"
                    style={{
                      ...btnUnapproveIcon,
                      opacity: unapprovingId === inv.id ? 0.6 : 1,
                      cursor: unapprovingId === inv.id ? "not-allowed" : "pointer",
                    }}
                  >
                    {unapprovingId === inv.id ? "⏳" : "🔓"}
                  </button>
                )}
              </div>
            </div>

            <p style={{ margin: "6px 0", color: "#555" }}>
              🧾 رقم الفاتورة: {inv.invoiceNumber}
            </p>

            <p style={{ margin: "6px 0", color: "#555" }}>
              📅 التاريخ: {getInvoiceDisplayDate(inv)}
            </p>

            <p style={{ margin: "6px 0", color: "#555" }}>
              👩‍💼 تم الإنشاء بواسطة: {resolveCreatedByName(inv.createdBy)}
            </p>

            <p style={{ margin: "6px 0", color: "#555" }}>
              🔢 آخر نسخة: V{inv.lastVersionNumber}
            </p>

            <p style={{ margin: "6px 0", color: "#333", fontWeight: "600" }}>
              💰 المجموع النهائي:{" "}
              {inv.lastFinalTotal
                ? inv.lastFinalTotal.toLocaleString()
                : "—"}
              د.ع
            </p>

            <button
              onClick={(e) => {
                e.stopPropagation();
                navigate(`/invoice/${inv.id}`);
              }}
              style={btnOpen}
            >
              فتح الفاتورة
            </button>

            {isAdmin && (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  openDeleteFlow(inv);
                }}
                disabled={deletingId === inv.id}
                style={{
                  ...btnDelete,
                  opacity: deletingId === inv.id ? 0.7 : 1,
                  cursor: deletingId === inv.id ? "not-allowed" : "pointer",
                }}
              >
                {deletingId === inv.id ? "⏳ جاري الحذف..." : "🗑️ حذف الفاتورة"}
              </button>
            )}
          </div>
        ))}
      </div>
      )}

      {deleteChoiceTarget && (
        <div style={modalOverlay} onClick={() => setDeleteChoiceTarget(null)}>
          <div style={modalBox} onClick={(e) => e.stopPropagation()}>
            <h3 style={{ marginTop: 0 }}>
              🗑️ حذف الفاتورة رقم {deleteChoiceTarget.invoiceNumber}
            </h3>

            <p style={{ color: "#555", lineHeight: 1.6 }}>
              هذه الفاتورة <strong>معتمدة</strong>
              {deleteChoiceTarget.orderId
                ? " وقد يكون تحوّل منها طلب فعلي."
                : "، ولا يوجد حالياً طلب مرتبط بها."}
              {" "}اختر الإجراء المناسب:
            </p>

            <button style={modalBtnDanger} onClick={confirmDeleteAllFromModal}>
              🗑️ حذف الفاتورة بالكامل
              <div style={modalBtnSubtext}>
                يحذف الفاتورة + كل نسخها + الطلب المرتبط (إن وجد) + كل القيود المحاسبية - لا يمكن التراجع
              </div>
            </button>

            <button
              style={modalBtnSecondary}
              onClick={confirmDeleteOrderOnlyFromModal}
            >
              ↩️ حذف الطلب فقط (وإرجاع الفاتورة لغير معتمدة)
              <div style={modalBtnSubtext}>
                {deleteChoiceTarget.orderId
                  ? "يحذف الطلب المرتبط فقط مع أي دفعة مقدمة عليه - الفاتورة نفسها تبقى موجودة وتصير قابلة للتعديل وإعادة الاعتماد لاحقاً"
                  : "لا يوجد طلب لحذفه - سيتم فقط إرجاع الفاتورة لحالة غير معتمدة ليمكن تعديلها"}
              </div>
            </button>

            <button
              style={modalBtnCancel}
              onClick={() => setDeleteChoiceTarget(null)}
            >
              إلغاء
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

/* ====== STYLES ====== */

// 🗂️ عرض السطور (الفواتير المعتمدة)
const invoiceRow = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: 12,
  flexWrap: "wrap",
  background: "#fff",
  padding: "12px 16px",
  borderRadius: 10,
  marginBottom: 10,
  boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
  border: "1px solid #e5e5e5",
  cursor: "pointer",
};

const rowAmounts = {
  display: "flex",
  gap: 8,
  flexWrap: "wrap",
};

const amountBox = {
  minWidth: 130,
  padding: "6px 12px",
  borderRadius: 6,
  fontWeight: 700,
  fontSize: 16,
  textAlign: "center",
  direction: "ltr",
  color: "#111",
};

const amountYellow = { background: "#fff176" };
const amountGreen = { background: "#81e979" };
const amountRed = { background: "#f26b5b" };

const rowsSummaryBar = {
  display: "flex",
  gap: 10,
  flexWrap: "wrap",
  alignItems: "center",
  background: "#fff",
  padding: 12,
  borderRadius: 10,
  marginBottom: 14,
  boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
};

const summaryAmountBox = {
  fontSize: 20,
  padding: "8px 16px",
  display: "flex",
  flexDirection: "column",
  gap: 2,
};

const summaryLabel = {
  fontSize: 12,
  fontWeight: 600,
  direction: "rtl",
};

const inputFilter = {
  padding: "10px",
  borderRadius: "6px",
  border: "1px solid #ccc",
  minWidth: 180,
  fontSize: 14,
};

const countsRow = {
  display: "flex",
  gap: 12,
  flexWrap: "wrap",
  marginTop: 12,
};

const countsGroup = {
  display: "flex",
  alignItems: "center",
  gap: 8,
  flexWrap: "wrap",
  padding: "8px 10px",
  borderRadius: 8,
  background: "#f8f9fa",
  border: "1px solid #e9ecef",
};

const countsGroupLabel = {
  fontWeight: 700,
  fontSize: 14,
  color: "#333",
};

const countChip = {
  border: "1px solid transparent",
  borderRadius: 20,
  padding: "6px 12px",
  fontSize: 13,
  cursor: "pointer",
  whiteSpace: "nowrap",
};

const countChipTotal = { background: "#e7f1ff", color: "#084298", borderColor: "#b6d4fe" };
const countChipApproved = { background: "#d4edda", color: "#155724", borderColor: "#c3e6cb" };
const countChipPending = { background: "#fff3cd", color: "#856404", borderColor: "#ffe69c" };

const btnOpen = {
  width: "100%",
  background: "#0d6efd",
  color: "#fff",
  border: "none",
  padding: "10px",
  borderRadius: 6,
  marginTop: 10,
  cursor: "pointer",
  fontWeight: "600",
};

const modalOverlay = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: "rgba(0,0,0,0.5)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 1000,
  padding: 16,
};

const modalBox = {
  background: "#fff",
  borderRadius: 10,
  padding: 24,
  maxWidth: 480,
  width: "100%",
  boxShadow: "0 8px 30px rgba(0,0,0,0.25)",
  direction: "rtl",
};

const modalBtnBase = {
  width: "100%",
  textAlign: "right",
  border: "none",
  borderRadius: 8,
  padding: "12px 14px",
  marginTop: 10,
  cursor: "pointer",
  fontWeight: "700",
  fontSize: 14,
};

const modalBtnDanger = {
  ...modalBtnBase,
  background: "#dc3545",
  color: "#fff",
};

const modalBtnSecondary = {
  ...modalBtnBase,
  background: "#fff3cd",
  color: "#664d03",
  border: "1px solid #ffe69c",
};

const modalBtnCancel = {
  ...modalBtnBase,
  background: "#e9ecef",
  color: "#333",
  fontWeight: "600",
  textAlign: "center",
};

const modalBtnSubtext = {
  fontWeight: "400",
  fontSize: 12,
  marginTop: 4,
  opacity: 0.9,
};

const btnDelete = {
  width: "100%",
  background: "#dc3545",
  color: "#fff",
  border: "none",
  padding: "10px",
  borderRadius: 6,
  marginTop: 8,
  fontWeight: "600",
};

const btnUnapproveIcon = {
  background: "#fff",
  color: "#c62828",
  border: "1px solid #c62828",
  borderRadius: "50%",
  width: 22,
  height: 22,
  minWidth: 22,
  padding: 0,
  fontSize: 12,
  lineHeight: "20px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

export default InvoiceListPage;
